import React from 'react';
import Slider from 'react-slick';
import {Card, CardTitle, CardDescription, Icon, Title} from './CardSlider.styles';

const NextArrow = (props) => {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{ ...style, display: "block", background: "red" }}
      onClick={onClick}
    >N</div>
  );
};
const PrevArrow = (props) => {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{ ...style, display: "block", background: "green" }}
      onClick={onClick}
    >P</div>
  );
};

const CardComponent = ({ title, description, icon, isCardCenter }) => {
  return (
    <Card id={'CardComponent'} style={{textAlign: isCardCenter ?  'center' : 'flex-start'}}>
      <CardTitle isCenter={isCardCenter}>
        {icon && <Icon src={icon} alt="Ícono" />}
        <Title isCenter={isCardCenter}>{title}</Title>
      </CardTitle>
      <CardDescription isCenter={isCardCenter}>{description}</CardDescription>
    </Card>
  );
};

const settings = {
  dots: false,
  infinite: true,
  speed: 500,
  slidesToShow: 3,
  slidesToScroll: 1,
  nextArrow: <NextArrow />,
  prevArrow: <PrevArrow />,
};

const CardSlider = ({cards, isCenter = false}) => {
  return (
    <Slider {...settings}>
      {cards.map((card, index) => (
        <CardComponent key={index} {...card} isCardCenter={isCenter} />
      ))}
    </Slider>
  );
};

export default CardSlider;
